
function drawDude(c, colour) {
    c.fillStyle = 'white';

    c.fillRect(120, 100, 10, 10);
    c.fillRect(130, 100, 10, 10);
    c.fillRect(140, 100, 10, 10);
    c.fillRect(150, 100, 10, 10);
    c.fillRect(160, 100, 10, 10);
    c.fillRect(170, 100, 10, 10);
    c.fillRect(180, 100, 10, 10);
    c.fillRect(190, 100, 10, 10);

    c.fillRect(110, 110, 10, 10);
    c.fillRect(120, 110, 10, 10);
    c.fillRect(130, 110, 10, 10);
    c.fillRect(140, 110, 10, 10);
    c.fillRect(150, 110, 10, 10);
    c.fillRect(160, 110, 10, 10);
    c.fillRect(170, 110, 10, 10);
    c.fillRect(180, 110, 10, 10);
    c.fillRect(190, 110, 10, 10);
    c.fillRect(200, 110, 10, 10);

    c.fillRect(100, 120, 10, 10);
    c.fillRect(110, 120, 10, 10);
    c.fillRect(120, 120, 10, 10);
    c.fillRect(130, 120, 10, 10);
    c.fillRect(140, 120, 10, 10);
    c.fillRect(150, 120, 10, 10);
    c.fillRect(160, 120, 10, 10);
    c.fillRect(170, 120, 10, 10);
    c.fillRect(180, 120, 10, 10);
    c.fillRect(190, 120, 10, 10);
    c.fillRect(200, 120, 10, 10);
    c.fillRect(210, 120, 10, 10);

    c.fillRect(90, 130, 10, 10);
    c.fillRect(100, 130, 10, 10);
    c.fillRect(110, 130, 10, 10);
    c.fillRect(120, 130, 10, 10);
    c.fillRect(130, 130, 10, 10);
    c.fillRect(140, 130, 10, 10);
    c.fillRect(150, 130, 10, 10);
    c.fillRect(160, 130, 10, 10);
    c.fillRect(170, 130, 10, 10);
    c.fillRect(180, 130, 10, 10);
    c.fillRect(190, 130, 10, 10);
    c.fillRect(200, 130, 10, 10);
    c.fillRect(210, 130, 10, 10);
    c.fillRect(220, 130, 10, 10);

    c.fillRect(90, 140, 10, 10);
    c.fillRect(100, 140, 10, 10);
    c.fillRect(110, 140, 10, 10);
    c.fillRect(120, 140, 10, 10);
    c.fillRect(130, 140, 10, 10);
    c.fillRect(140, 140, 10, 10);
    c.fillRect(150, 140, 10, 10);
    c.fillRect(160, 140, 10, 10);
    c.fillRect(170, 140, 10, 10);
    c.fillRect(180, 140, 10, 10);
    c.fillRect(190, 140, 10, 10);
    c.fillRect(200, 140, 10, 10);
    c.fillRect(210, 140, 10, 10);
    c.fillRect(220, 140, 10, 10);

    c.fillRect(100, 150, 10, 10);
    c.fillRect(110, 150, 10, 10);
    c.fillRect(120, 150, 10, 10);
    c.fillRect(130, 150, 10, 10);
    c.fillRect(140, 150, 10, 10);
    c.fillRect(150, 150, 10, 10);
    c.fillRect(160, 150, 10, 10);
    c.fillRect(170, 150, 10, 10);
    c.fillRect(180, 150, 10, 10);
    c.fillRect(190, 150, 10, 10);
    c.fillRect(200, 150, 10, 10);
    c.fillRect(210, 150, 10, 10);

    c.fillRect(90, 160, 10, 10);
    c.fillRect(100, 160, 10, 10);
    c.fillRect(110, 160, 10, 10);
    c.fillRect(120, 160, 10, 10);
    c.fillRect(130, 160, 10, 10);
    c.fillRect(140, 160, 10, 10);
    c.fillRect(150, 160, 10, 10);
    c.fillRect(160, 160, 10, 10);
    c.fillRect(170, 160, 10, 10);
    c.fillRect(180, 160, 10, 10);
    c.fillRect(190, 160, 10, 10);
    c.fillRect(200, 160, 10, 10);
    c.fillRect(210, 160, 10, 10);
    c.fillRect(220, 160, 10, 10);

    c.fillRect(90, 170, 10, 10);
    c.fillRect(100, 170, 10, 10);
    c.fillRect(110, 170, 10, 10);
    c.fillRect(120, 170, 10, 10);
    c.fillRect(130, 170, 10, 10);
    c.fillRect(140, 170, 10, 10);
    c.fillRect(150, 170, 10, 10);
    c.fillRect(160, 170, 10, 10);
    c.fillRect(170, 170, 10, 10);
    c.fillRect(180, 170, 10, 10);
    c.fillRect(190, 170, 10, 10);
    c.fillRect(200, 170, 10, 10);
    c.fillRect(210, 170, 10, 10);
    c.fillRect(220, 170, 10, 10);

    c.fillRect(90, 180, 10, 10);
    c.fillRect(100, 180, 10, 10);
    c.fillRect(110, 180, 10, 10);
    c.fillRect(120, 180, 10, 10);
    c.fillRect(130, 180, 10, 10);
    c.fillRect(140, 180, 10, 10);
    c.fillRect(150, 180, 10, 10);
    c.fillRect(160, 180, 10, 10);
    c.fillRect(170, 180, 10, 10);
    c.fillRect(180, 180, 10, 10);
    c.fillRect(190, 180, 10, 10);
    c.fillRect(200, 180, 10, 10);
    c.fillRect(210, 180, 10, 10);
    c.fillRect(220, 180, 10, 10);

    c.fillRect(90, 190, 10, 10);
    c.fillRect(100, 190, 10, 10);
    c.fillRect(110, 190, 10, 10);
    c.fillRect(120, 190, 10, 10);
    c.fillRect(130, 190, 10, 10);
    c.fillRect(140, 190, 10, 10);
    c.fillRect(150, 190, 10, 10);
    c.fillRect(160, 190, 10, 10);
    c.fillRect(170, 190, 10, 10);
    c.fillRect(180, 190, 10, 10);
    c.fillRect(190, 190, 10, 10);
    c.fillRect(200, 190, 10, 10);
    c.fillRect(210, 190, 10, 10);
    c.fillRect(220, 190, 10, 10);

    c.fillRect(100, 200, 10, 10);
    c.fillRect(110, 200, 10, 10);
    c.fillRect(120, 200, 10, 10);
    c.fillRect(130, 200, 10, 10);
    c.fillRect(140, 200, 10, 10);
    c.fillRect(150, 200, 10, 10);
    c.fillRect(160, 200, 10, 10);
    c.fillRect(170, 200, 10, 10);
    c.fillRect(180, 200, 10, 10);
    c.fillRect(190, 200, 10, 10);
    c.fillRect(200, 200, 10, 10);
    c.fillRect(210, 200, 10, 10);

    c.fillRect(120, 210, 10, 10);
    c.fillRect(130, 210, 10, 10);
    c.fillRect(140, 210, 10, 10);
    c.fillRect(150, 210, 10, 10);
    c.fillRect(160, 210, 10, 10);
    c.fillRect(170, 210, 10, 10);
    c.fillRect(180, 210, 10, 10);
    c.fillRect(190, 210, 10, 10);

    c.fillStyle = colour;
    c.fillRect(120, 100, 10, 10);
    c.fillRect(130, 100, 10, 10);
    c.fillRect(140, 100, 10, 10);
    c.fillRect(150, 100, 10, 10);
    c.fillRect(160, 100, 10, 10);
    c.fillRect(170, 100, 10, 10);
    c.fillRect(180, 100, 10, 10);
    c.fillRect(190, 100, 10, 10);

    c.fillRect(110, 110, 10, 10);
    c.fillRect(200, 110, 10, 10);

    c.fillRect(100, 120, 10, 10);
    c.fillRect(210, 120, 10, 10);

    c.fillRect(90, 130, 10, 10);
    c.fillRect(120, 130, 10, 10);
    c.fillRect(130, 130, 10, 10);
    c.fillRect(160, 130, 10, 10);
    c.fillRect(180, 130, 10, 10);
    c.fillRect(190, 130, 10, 10);
    c.fillRect(220, 130, 10, 10);

    c.fillRect(90, 140, 10, 10);
    c.fillRect(120, 140, 10, 10);
    c.fillRect(130, 140, 10, 10);
    c.fillRect(160, 140, 10, 10);
    c.fillRect(180, 140, 10, 10);
    c.fillRect(190, 140, 10, 10);
    c.fillRect(220, 140, 10, 10);

    c.fillRect(100, 150, 10, 10);
    c.fillRect(150, 150, 10, 10);
    c.fillRect(160, 150, 10, 10);
    c.fillRect(210, 150, 10, 10);

    c.fillRect(90, 160, 10, 10);
    c.fillRect(110, 160, 10, 10);
    c.fillRect(200, 160, 10, 10);
    c.fillRect(220, 160, 10, 10);

    c.fillRect(90, 170, 10, 10);
    c.fillRect(110, 170, 10, 10);
    c.fillRect(120, 170, 10, 10);
    c.fillRect(130, 170, 10, 10);
    c.fillRect(140, 170, 10, 10);
    c.fillRect(150, 170, 10, 10);
    c.fillRect(160, 170, 10, 10);
    c.fillRect(170, 170, 10, 10);
    c.fillRect(180, 170, 10, 10);
    c.fillRect(190, 170, 10, 10);
    c.fillRect(200, 170, 10, 10);
    c.fillRect(220, 170, 10, 10);

    c.fillRect(90, 180, 10, 10);
    c.fillRect(110, 180, 10, 10);
    c.fillRect(130, 180, 10, 10);
    c.fillRect(150, 180, 10, 10);
    c.fillRect(160, 180, 10, 10);
    c.fillRect(180, 180, 10, 10);
    c.fillRect(200, 180, 10, 10);
    c.fillRect(220, 180, 10, 10);

    c.fillRect(90, 190, 10, 10);
    c.fillRect(120, 190, 10, 10);
    c.fillRect(130, 190, 10, 10);
    c.fillRect(140, 190, 10, 10);
    c.fillRect(150, 190, 10, 10);
    c.fillRect(160, 190, 10, 10);
    c.fillRect(170, 190, 10, 10);
    c.fillRect(180, 190, 10, 10);
    c.fillRect(190, 190, 10, 10);
    c.fillRect(220, 190, 10, 10);

    c.fillRect(100, 200, 10, 10);
    c.fillRect(110, 200, 10, 10);
    c.fillRect(200, 200, 10, 10);
    c.fillRect(210, 200, 10, 10);

    c.fillRect(120, 210, 10, 10);
    c.fillRect(130, 210, 10, 10);
    c.fillRect(140, 210, 10, 10);
    c.fillRect(150, 210, 10, 10);
    c.fillRect(160, 210, 10, 10);
    c.fillRect(170, 210, 10, 10);
    c.fillRect(180, 210, 10, 10);
    c.fillRect(190, 210, 10, 10);
}

function drawTude(c, colour) {
    c.fillStyle = 'white';
    c.strokeStyle = 'black';
    c.beginPath();
    c.arc(160, 150, 60, 0, 2 * Math.PI);
    c.fill();
    c.stroke();


    c.fillStyle = colour;
    c.fillRect(130, 180, 10, 10);
    c.fillRect(140, 180, 10, 10);
    c.fillRect(150, 180, 10, 10);
    c.fillRect(160, 180, 10, 10);
    c.fillRect(170, 180, 10, 10);
    c.fillRect(180, 180, 10, 10);

    c.fillRect(130, 170, 10, 10);
    c.fillRect(180, 170, 10, 10);

    c.fillRect(120, 150, 10, 10);
    c.fillRect(130, 150, 10, 10);
    c.fillRect(180, 150, 10, 10);
    c.fillRect(190, 150, 10, 10);

    c.fillRect(120, 140, 10, 10);
    c.fillRect(130, 140, 10, 10);
    c.fillRect(180, 140, 10, 10);
    c.fillRect(190, 140, 10, 10);
}

function drawAude(c, colour) {
    c.fillStyle = 'white';
    c.strokeStyle = 'black';
    c.beginPath();
    c.arc(160, 150, 60, 0, 2 * Math.PI);
    c.fill();
    c.stroke();

    c.fillStyle = 'pink';
    c.fillRect(160, 190, 10, 10);

    c.fillRect(150, 180, 10, 10);
    c.fillRect(160, 180, 10, 10);
    c.fillRect(170, 180, 10, 10);

    c.fillStyle = colour;
    c.fillRect(130, 170, 10, 10);
    c.fillRect(140, 170, 10, 10);
    c.fillRect(150, 170, 10, 10);
    c.fillRect(160, 170, 10, 10);
    c.fillRect(170, 170, 10, 10);
    c.fillRect(180, 170, 10, 10);

    c.fillRect(120, 150, 10, 10);
    c.fillRect(190, 150, 10, 10);

    c.fillRect(120, 140, 10, 10);
    c.fillRect(130, 140, 10, 10);
    c.fillRect(180, 140, 10, 10);
    c.fillRect(190, 140, 10, 10);
}

function drawBude(c, colour) {
    c.fillStyle = 'white';
    c.strokeStyle = 'black';
    c.beginPath();
    c.arc(160, 150, 60, 0, 2 * Math.PI);
    c.fill();
    c.stroke();

    c.fillStyle = colour;
    c.fillRect(130, 170, 10, 10);
    c.fillRect(140, 170, 10, 10);
    c.fillRect(150, 170, 10, 10);
    c.fillRect(160, 170, 10, 10);
    c.fillRect(170, 170, 10, 10);
    c.fillRect(180, 170, 10, 10);

    c.fillRect(130, 180, 10, 10);
    c.fillRect(140, 180, 10, 10);
    c.fillRect(150, 180, 10, 10);
    c.fillRect(160, 180, 10, 10);
    c.fillRect(170, 180, 10, 10);
    c.fillRect(180, 180, 10, 10);

    c.fillRect(120, 150, 10, 10);
    c.fillRect(190, 150, 10, 10);

    c.fillRect(120, 140, 10, 10);
    c.fillRect(190, 140, 10, 10);

    c.fillRect(120, 160, 10, 10);
    c.fillRect(190, 160, 10, 10);
}

function drawCude(c, colour) {
    c.fillStyle = 'white';

    c.fillRect(120, 100, 10, 10);
    c.fillRect(130, 100, 10, 10);
    c.fillRect(140, 100, 10, 10);
    c.fillRect(150, 100, 10, 10);
    c.fillRect(160, 100, 10, 10);
    c.fillRect(170, 100, 10, 10);
    c.fillRect(180, 100, 10, 10);
    c.fillRect(190, 100, 10, 10);

    c.fillRect(110, 110, 10, 10);
    c.fillRect(120, 110, 10, 10);
    c.fillRect(130, 110, 10, 10);
    c.fillRect(140, 110, 10, 10);
    c.fillRect(150, 110, 10, 10);
    c.fillRect(160, 110, 10, 10);
    c.fillRect(170, 110, 10, 10);
    c.fillRect(180, 110, 10, 10);
    c.fillRect(190, 110, 10, 10);
    c.fillRect(200, 110, 10, 10);

    c.fillRect(100, 120, 10, 10);
    c.fillRect(110, 120, 10, 10);
    c.fillRect(120, 120, 10, 10);
    c.fillRect(130, 120, 10, 10);
    c.fillRect(140, 120, 10, 10);
    c.fillRect(150, 120, 10, 10);
    c.fillRect(160, 120, 10, 10);
    c.fillRect(170, 120, 10, 10);
    c.fillRect(180, 120, 10, 10);
    c.fillRect(190, 120, 10, 10);
    c.fillRect(200, 120, 10, 10);
    c.fillRect(210, 120, 10, 10);

    c.fillRect(90, 130, 10, 10);
    c.fillRect(100, 130, 10, 10);
    c.fillRect(110, 130, 10, 10);
    c.fillRect(120, 130, 10, 10);
    c.fillRect(130, 130, 10, 10);
    c.fillRect(140, 130, 10, 10);
    c.fillRect(150, 130, 10, 10);
    c.fillRect(160, 130, 10, 10);
    c.fillRect(170, 130, 10, 10);
    c.fillRect(180, 130, 10, 10);
    c.fillRect(190, 130, 10, 10);
    c.fillRect(200, 130, 10, 10);
    c.fillRect(210, 130, 10, 10);
    c.fillRect(220, 130, 10, 10);

    c.fillRect(90, 140, 10, 10);
    c.fillRect(100, 140, 10, 10);
    c.fillRect(110, 140, 10, 10);
    c.fillRect(120, 140, 10, 10);
    c.fillRect(130, 140, 10, 10);
    c.fillRect(140, 140, 10, 10);
    c.fillRect(150, 140, 10, 10);
    c.fillRect(160, 140, 10, 10);
    c.fillRect(170, 140, 10, 10);
    c.fillRect(180, 140, 10, 10);
    c.fillRect(190, 140, 10, 10);
    c.fillRect(200, 140, 10, 10);
    c.fillRect(210, 140, 10, 10);
    c.fillRect(220, 140, 10, 10);

    c.fillRect(100, 150, 10, 10);
    c.fillRect(110, 150, 10, 10);
    c.fillRect(120, 150, 10, 10);
    c.fillRect(130, 150, 10, 10);
    c.fillRect(140, 150, 10, 10);
    c.fillRect(150, 150, 10, 10);
    c.fillRect(160, 150, 10, 10);
    c.fillRect(170, 150, 10, 10);
    c.fillRect(180, 150, 10, 10);
    c.fillRect(190, 150, 10, 10);
    c.fillRect(200, 150, 10, 10);
    c.fillRect(210, 150, 10, 10);

    c.fillRect(90, 160, 10, 10);
    c.fillRect(100, 160, 10, 10);
    c.fillRect(110, 160, 10, 10);
    c.fillRect(120, 160, 10, 10);
    c.fillRect(130, 160, 10, 10);
    c.fillRect(140, 160, 10, 10);
    c.fillRect(150, 160, 10, 10);
    c.fillRect(160, 160, 10, 10);
    c.fillRect(170, 160, 10, 10);
    c.fillRect(180, 160, 10, 10);
    c.fillRect(190, 160, 10, 10);
    c.fillRect(200, 160, 10, 10);
    c.fillRect(210, 160, 10, 10);
    c.fillRect(220, 160, 10, 10);

    c.fillRect(90, 170, 10, 10);
    c.fillRect(100, 170, 10, 10);
    c.fillRect(110, 170, 10, 10);
    c.fillRect(120, 170, 10, 10);
    c.fillRect(130, 170, 10, 10);
    c.fillRect(140, 170, 10, 10);
    c.fillRect(150, 170, 10, 10);
    c.fillRect(160, 170, 10, 10);
    c.fillRect(170, 170, 10, 10);
    c.fillRect(180, 170, 10, 10);
    c.fillRect(190, 170, 10, 10);
    c.fillRect(200, 170, 10, 10);
    c.fillRect(210, 170, 10, 10);
    c.fillRect(220, 170, 10, 10);

    c.fillRect(90, 180, 10, 10);
    c.fillRect(100, 180, 10, 10);
    c.fillRect(110, 180, 10, 10);
    c.fillRect(120, 180, 10, 10);
    c.fillRect(130, 180, 10, 10);
    c.fillRect(140, 180, 10, 10);
    c.fillRect(150, 180, 10, 10);
    c.fillRect(160, 180, 10, 10);
    c.fillRect(170, 180, 10, 10);
    c.fillRect(180, 180, 10, 10);
    c.fillRect(190, 180, 10, 10);
    c.fillRect(200, 180, 10, 10);
    c.fillRect(210, 180, 10, 10);
    c.fillRect(220, 180, 10, 10);

    c.fillRect(90, 190, 10, 10);
    c.fillRect(100, 190, 10, 10);
    c.fillRect(110, 190, 10, 10);
    c.fillRect(120, 190, 10, 10);
    c.fillRect(130, 190, 10, 10);
    c.fillRect(140, 190, 10, 10);
    c.fillRect(150, 190, 10, 10);
    c.fillRect(160, 190, 10, 10);
    c.fillRect(170, 190, 10, 10);
    c.fillRect(180, 190, 10, 10);
    c.fillRect(190, 190, 10, 10);
    c.fillRect(200, 190, 10, 10);
    c.fillRect(210, 190, 10, 10);
    c.fillRect(220, 190, 10, 10);

    c.fillRect(100, 200, 10, 10);
    c.fillRect(110, 200, 10, 10);
    c.fillRect(120, 200, 10, 10);
    c.fillRect(130, 200, 10, 10);
    c.fillRect(140, 200, 10, 10);
    c.fillRect(150, 200, 10, 10);
    c.fillRect(160, 200, 10, 10);
    c.fillRect(170, 200, 10, 10);
    c.fillRect(180, 200, 10, 10);
    c.fillRect(190, 200, 10, 10);
    c.fillRect(200, 200, 10, 10);
    c.fillRect(210, 200, 10, 10);

    c.fillRect(120, 210, 10, 10);
    c.fillRect(130, 210, 10, 10);
    c.fillRect(140, 210, 10, 10);
    c.fillRect(150, 210, 10, 10);
    c.fillRect(160, 210, 10, 10);
    c.fillRect(170, 210, 10, 10);
    c.fillRect(180, 210, 10, 10);
    c.fillRect(190, 210, 10, 10);

    c.fillStyle = colour;
    c.fillRect(120, 100, 10, 10);
    c.fillRect(130, 100, 10, 10);
    c.fillRect(140, 100, 10, 10);
    c.fillRect(150, 100, 10, 10);
    c.fillRect(160, 100, 10, 10);
    c.fillRect(170, 100, 10, 10);
    c.fillRect(180, 100, 10, 10);
    c.fillRect(190, 100, 10, 10);

    c.fillRect(110, 110, 10, 10);
    c.fillRect(200, 110, 10, 10);

    c.fillRect(100, 120, 10, 10);
    c.fillRect(210, 120, 10, 10);

    c.fillRect(90, 130, 10, 10);
    c.fillRect(120, 130, 10, 10);
    c.fillRect(130, 130, 10, 10);
    c.fillRect(160, 130, 10, 10);
    c.fillRect(180, 130, 10, 10);
    c.fillRect(190, 130, 10, 10);
    c.fillRect(220, 130, 10, 10);

    c.fillRect(90, 140, 10, 10);
    c.fillRect(120, 140, 10, 10);
    c.fillRect(130, 140, 10, 10);
    c.fillRect(160, 140, 10, 10);
    c.fillRect(180, 140, 10, 10);
    c.fillRect(190, 140, 10, 10);
    c.fillRect(220, 140, 10, 10);

    c.fillRect(100, 150, 10, 10);
    c.fillRect(150, 150, 10, 10);
    c.fillRect(160, 150, 10, 10);
    c.fillRect(210, 150, 10, 10);

    c.fillRect(90, 160, 10, 10);
    c.fillRect(110, 160, 10, 10);
    c.fillRect(200, 160, 10, 10);
    c.fillRect(220, 160, 10, 10);

    c.fillRect(90, 170, 10, 10);
    c.fillRect(110, 170, 10, 10);
    c.fillRect(120, 170, 10, 10);
    c.fillRect(130, 170, 10, 10);
    c.fillRect(140, 170, 10, 10);
    c.fillRect(150, 170, 10, 10);
    c.fillRect(160, 170, 10, 10);
    c.fillRect(170, 170, 10, 10);
    c.fillRect(180, 170, 10, 10);
    c.fillRect(190, 170, 10, 10);
    c.fillRect(200, 170, 10, 10);
    c.fillRect(220, 170, 10, 10);

    c.fillRect(90, 180, 10, 10);
    c.fillRect(110, 180, 10, 10);
    c.fillRect(130, 180, 10, 10);
    c.fillRect(180, 180, 10, 10);
    c.fillRect(200, 180, 10, 10);
    c.fillRect(220, 180, 10, 10);

    c.fillRect(90, 190, 10, 10);
    c.fillRect(120, 190, 10, 10);
    c.fillRect(130, 190, 10, 10);
    c.fillRect(180, 190, 10, 10);
    c.fillRect(190, 190, 10, 10);
    c.fillRect(220, 190, 10, 10);

    c.fillRect(100, 200, 10, 10);
    c.fillRect(110, 200, 10, 10);
    c.fillRect(200, 200, 10, 10);
    c.fillRect(210, 200, 10, 10);

    c.fillRect(120, 210, 10, 10);
    c.fillRect(130, 210, 10, 10);
    c.fillRect(140, 210, 10, 10);
    c.fillRect(150, 210, 10, 10);
    c.fillRect(160, 210, 10, 10);
    c.fillRect(170, 210, 10, 10);
    c.fillRect(180, 210, 10, 10);
    c.fillRect(190, 210, 10, 10);
}

function drawEmpty(c, colour) {}

var faces = {
    dude: drawDude,
    tude: drawTude,
    aude: drawAude,
    bude: drawBude,
    cude: drawCude,
    empty: drawEmpty
}

export {faces as default};